<template>
  <gj-modal
      :visible.sync="modalVisible"
      :confirm-loading="confirmLoading"
      @confirm="confirm"
      @cancel="cancel"
  >
    <template #header>
      其他{{type === documentTypeEnum.INBOUND ? '入库' : '出库'}}
    </template>
    <template #content>
      <el-form
          ref="form"
          :model="form"
          label-width="100px"
      >
        <gj-area-title>基本信息</gj-area-title>
        <el-row>
          <el-col :span="8">
            <el-form-item
                prop="warehouseId"
                label="仓库"
                :rules="[
                  $gjRequired('请选择仓库')
                ]"
            >
              <gj-warehouse-select
                  v-model="form.warehouseId"
                  :fba="false"
                  placeholder="自营仓"
                  width="200px"
                  :noValid="true"
                  @input="changeWarehouse"
              ></gj-warehouse-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
                label="单据类型"
                required
            >
              {{type === documentTypeEnum.INBOUND ? '入库' : '出库'}}
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
                label="操作类型"
                required
            >
              其他{{type === documentTypeEnum.INBOUND ? '入库' : '出库'}}
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item
                prop="childOpType"
                label="子操作类型"
                :rules="[
                  $gjRequired('请选择子操作类型')
                ]"
            >
              <gj-select
                  v-model="form.childOpType"
                  :options="childOpTypeOption"
                  placeholder="请选择子操作类型"
                  :clearable="false"
                  width="200px"
              ></gj-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
                label="备注"
            >
              <gj-input
                  v-model="form.memo"
                  width="200px"
              ></gj-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="type === documentTypeEnum.INBOUND" style="padding-bottom: 8px">
          <el-col :span="8">
            <el-form-item
                label="运费"
                prop="transportFeeObj.value"
                :rules="[
                  $gjReRule(RE.num(2), '最多两位小数的正数'),
                  $gjMinRule(0.02, '应大于等于0.02'),
                ]">
                <gj-select-input
                  v-model="form.transportFeeObj"
                  @input="transportFeeInput"
                  :options="[
                      {id: 'CNY', text: 'CNY'},
                      {id: 'USD', text: 'USD'}
                  ]"
                  :width="['85px', '114px']"
                ></gj-select-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
                label="其他费用"
                prop="otherFeeObj.value"
                :rules="[
                  $gjReRule(RE.num(2), '最多两位小数的正数'),
                  $gjMinRule(0.02, '应大于等于0.02'),
                ]">
                <gj-select-input
                  v-model="form.otherFeeObj"
                  @input="otherFeeInput"
                  :options="[
                      {id: 'CNY', text: 'CNY'},
                      {id: 'USD', text: 'USD'}
                  ]"
                  :width="['85px', '115px']"
                ></gj-select-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
                label="分摊方式"
                prop="shareMethod">
                <gj-select
                  :options="[
                    {id: 'amount', text: '按金额'},
                    {id: 'quantity', text: '按数量'}
                  ]"
                  v-model="form.shareMethod"
                  :clearable="false"
                ></gj-select>
            </el-form-item>
          </el-col>
        </el-row>
        <div>
          <gj-area-title>{{type === documentTypeEnum.INBOUND ? '入库' : '出库'}}产品</gj-area-title>
          <div style="margin-bottom: 12px">
            <gj-button type="primary" @click="openImport" :disabled="isMeaningless(form.warehouseId)">导入</gj-button>
            <gj-button type="primary" @click="openAdd" :disabled="isMeaningless(form.warehouseId)">添加</gj-button>
          </div>
          <gj-table
              :data="form.items"
              :index="false"
              :min-height="300"
              :show-overflow="false"
              :scroll-y="{ enabled: false }"
              :columns="type === documentTypeEnum.INBOUND ? inboundColumns: outboundColumns"
              :offset-height="58"
          >
            <template v-slot:productInfo="{row}">
              <div>
                <gj-text width="100%" :content="row.skuName">{{row.productName}}</gj-text>
              </div>
              <div>
                <gj-text width="100%" :content="row.sku">{{row.sku}}</gj-text>
              </div>
            </template>
            <template v-if="type === documentTypeEnum.INBOUND" v-slot:purchaseCost="{row ,index}">
              <el-form-item
                  class="gj-table-item not-form-item-mgb"
                  label-width="0"
                  :prop="`items.${index}.purchaseCost`"
                  :rules="[
                    {required: true, message: '请输入含税单价', trigger: ['blur', 'change']},
                    $gjReRule(RE.num(2), '最多两位小数的正数'),
                  ]"
              >
                <gj-input
                    width="120px"
                    @input="changeTotal(row)"
                    v-model="form.items[index].purchaseCost"
                    placeholder="请输入">
                  <template #prepend>￥</template>
                </gj-input>
              </el-form-item>
            </template>
            <template v-slot:goodProduct="{row ,index}">
              <el-form-item
                  class="gj-table-item not-form-item-mgb"
                  label-width="0"
                  :prop="`items.${index}.changeQuantity`"
                  :rules="[
                    {required: true, message: '请输入良品量', trigger: ['blur', 'change']},
                    $gjReRule(RE.pt0, '请输入0或正整数')
                  ]"
              >
                <gj-input
                    width="120px"
                    v-model="form.items[index].changeQuantity"
                    @input="changeTotal(row)"
                    placeholder="请输入良品量"
                ></gj-input>
              </el-form-item>
            </template>
            <template v-slot:defective="{row ,index}">
              <el-form-item
                  class="gj-table-item not-form-item-mgb"
                  label-width="0"
                  :prop="`items.${index}.changeBadQuantity`"
                  :rules="[
                    {required: true, message: '请输入次品量', trigger: ['blur', 'change']},
                    $gjReRule(RE.pt0, '请输入0或正整数')
                  ]"
              >
                <gj-input
                    width="120px"
                    @input="changeTotal(row)"
                    v-model="form.items[index].changeBadQuantity"
                    placeholder="请输入次品量"
                ></gj-input>
              </el-form-item>
            </template>
            <template v-slot:memo="{index}">
              <el-form-item
                  label-width="0"
                  class="gj-table-item not-form-item-mgb"
              >
                <gj-input
                    width="150px"
                    v-model="form.items[index].memo"
                    placeholder="请输入备注"
                ></gj-input>
              </el-form-item>
            </template>
            <template v-slot:op="{index}">
              <gj-button type="text" @click="remove(index)">删除</gj-button>
            </template>
          </gj-table>
        </div>
      </el-form>
    </template>
  </gj-modal>
</template>

<script>
  import {formRuleMixin, isMeaninglessMixin, modalMixIn, responseMixin} from "../../../../../minxins";
  import AppImportInboundOutbound from './import-inbound-outbound';
  import AppAddInboundOutboundProduct from './inbound-outbound-add-product';
  import {getDictionaryCombobox} from "../../../../../api/common";
  import {isMeaningful} from "../../../../../utils/common";
  import {saveOtherInbound, saveOtherOutbound} from "../../../../../api/warehouse";
  import {opTypeEnum} from "../enum";

  export default {
    name: "other-inbound-outbound",
    mixins: [formRuleMixin, modalMixIn, isMeaninglessMixin, responseMixin],
    props: {
      type: null,
      documentTypeEnum: null,
    },
    created() {
      this.form.type = this.type;
      this.form.opType = this.type === this.documentTypeEnum.INBOUND ?
        this.opTypeEnum.OTHER_INBOUND : this.opTypeEnum.OTHER_OUTBOUND;
      getDictionaryCombobox(this.type === this.documentTypeEnum.INBOUND ?
        'OTHER_INBOUND_CHILD_OP_TYPE' : 'OTHER_OUTBOUND_CHILD_OP_TYPE')
        .then((data) => {
          this.childOpTypeOption = data;
        })
    },
    data() {
      return {
        form: {
          warehouseId: null,
          childOpType: null,
          opType: null,
          type: null,
          memo: null,
          items: [],
          transportFeeObj: {
            key: "CNY",
            value: ""
          },
          otherFeeObj: {
            key: "CNY",
            value: ""
          },
          shareMethod: "amount",
        },
        outboundColumns: [ // 出库
          {id: 'img', header: '图片', field: 'picture:skuImageUrl', minWidth: '50px'},
          {id: 'productInfo', header: '产品名称/SKU', field: 'slot:productInfo', minWidth: '180px'},
          {id: 'goodProduct', header: '良品量', field: 'slot:goodProduct', required: true, minWidth: '120px'},
          {id: 'defective', header: '次品量', field: 'slot:defective', required: true, minWidth: '120px'},
          {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '150px'},
          {id: 'op', header: '操作', field: 'slot:op', minWidth: '60px'},
        ],
        inboundColumns: [ // 入库
          {id: 'img', header: '图片', field: 'picture:skuImageUrl', minWidth: '50px'},
          {id: 'productInfo', header: '产品名称/SKU', field: 'slot:productInfo', minWidth: '180px'},
          {id: 'purchaseCost', header: '含税单价', field: 'slot:purchaseCost', required: true, minWidth: '120px'},
          {id: 'goodProduct', header: '良品量', field: 'slot:goodProduct', required: true, minWidth: '120px'},
          {id: 'defective', header: '次品量', field: 'slot:defective', required: true, minWidth: '120px'},
          {id: 'totalPurchaseCost', header: '金额', field: 'totalPurchaseCost', minWidth: '120px'},
          {id: 'memo', header: '备注', field: 'slot:memo', minWidth: '150px'},
          {id: 'op', header: '操作', field: 'slot:op', minWidth: '60px'},
        ],
        childOpTypeOption: [],
        opTypeEnum: opTypeEnum,
      }
    },
    methods: {
      // 其他费用改变
      otherFeeInput() {
        this.form.transportFeeObj.key = this.form.otherFeeObj.key
      },
      // 运费改变
      transportFeeInput() {
        this.form.otherFeeObj.key = this.form.transportFeeObj.key
      },
      // 处理总计
      changeTotal(row) {
        row.totalPurchaseCost = this._.round(Number(row.purchaseCost) * (Number(row.changeQuantity) + Number(row.changeBadQuantity)) ,2)
      },
      remove(index) {
        this.form.items.splice(index, 1);
      },
      changeWarehouse() {
        this.form.items = [];
      },
      openImport() {
        const modal = this.$gjCreate(AppImportInboundOutbound, {
          props: {
            type: this.type,
            warehouseId: this.form.warehouseId
          },
          on: {
            importSuccess: (data) => {
              if (isMeaningful(data) && data.length > 0) {
                data.forEach(v => {
                  if (this.form.items.every(k => k.sku !== v.sku)) {
                    this.form.items.push(v);
                  } else if (this.form.items.length > 0) {
                    this.form.items.forEach(k => {
                      if (k.sku === v.sku) {
                        k.changeBadQuantity = v.changeBadQuantity;
                        k.changeQuantity = v.changeQuantity;
                        k.memo = v.memo;
                      }
                    })
                  }
                })
              }
              modal.$gjDestroy();
            }
          }
        })
      },
      openAdd() {
        const modal = this.$gjCreate(AppAddInboundOutboundProduct, {
          props: {
            type: this.type,
            warehouseId: this.form.warehouseId,
            hideSkuList: this.form.items.map(v => v.sku)
          },
          on: {
            addConfirm: (data) => {
              this.form.items.push(...data);
              modal.$gjDestroy();
            }
          }
        })
      },
      confirm() {
        if (this.$gjFormValidate()) {
          this.confirmLoading = true;
          if (this.type === this.documentTypeEnum.INBOUND) {
            this.form.feeCurrency = this.form.transportFeeObj.key
            this.form.transportFee = this.form.transportFeeObj.value
            this.form.otherFee = this.form.otherFeeObj.value
            saveOtherInbound(this.form)
              .then((res) => {
                this.$gjResponseHandle(res, () => {
                  this.$gjMessage.success('操作成功');
                  this.$emit('after');
                })
              }).complete(() => this.confirmLoading = false)
          } else {
            saveOtherOutbound(this.form)
              .then((res) => {
                this.$gjResponseHandle(res, () => {
                  this.$gjMessage.success('操作成功');
                  this.$emit('after');
                })
              }).complete(() => this.confirmLoading = false)
          }
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .not-form-item-mgb {
    margin-bottom: 0;
  }
  /deep/ .el-dialog__body{
    padding-bottom: 0;
  }
  /deep/ .gj-table--default td.vxe-body--column{
    height: 56px !important;
  }
</style>
